module.exports = __webpack_public_path__ + "img/20200118115521346.e78dcd32.jpg";